import { IconSun, IconMoon } from '../../icons'
import { useTheme } from '../../theme'
import { cn } from '../../utils'
import { AppIcon } from '../AppIcon'

export function ThemeToggle({ className }: { className?: string }) {
  const { theme, toggleTheme } = useTheme()

  return (
    <button
      onClick={toggleTheme}
      className={cn(
        'rounded-xl p-2 transition-colors',
        'text-(--muted) hover:text-(--text)',
        className,
      )}
      aria-label={`Basculer en mode ${theme === 'dark' ? 'clair' : 'sombre'}`}
    >
      <AppIcon icon={theme === 'dark' ? IconSun : IconMoon} size={20} />
    </button>
  )
}
